import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ReplaceFile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [concernPersonName, setConcernPersonName] = useState("");
  const [concernPersonPhone, setConcernPersonPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file.");
      return;
    }

    setLoading(true);
    setError("");

    const user = JSON.parse(localStorage.getItem("user"));
    const userData = user ? user : null;

    if (!userData) {
      Swal.fire("Error", "User data not found", "error");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("issueDate", issueDate);
    formData.append("expiryDate", expiryDate);
    if (concernPersonName.trim()) {
      formData.append("concernPersonName", concernPersonName);
    }

    if (concernPersonPhone.trim()) {
      formData.append("concernPersonPhone", concernPersonPhone);
    }
    formData.append("userData", JSON.stringify(userData));

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/update-document/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        title: "Success!",
        text: "Document updated successfully.",
        icon: "success",
        confirmButtonColor: "#3085d6",
      });

      navigate("/home");
    } catch (error) {
      setError("Error updating document. Try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" style={{ minHeight: "80vh" }}>
      <div className="card shadow-lg p-4">
        <h2 className="text-center text-primary">Replace Document</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-bold">Upload New File</label>
            <input
              type="file"
              className="form-control"
              onChange={handleFileChange}
              accept="application/pdf"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Title:</label>
            <input
              type="text"
              name="title"
              className="form-control"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Issue Date</label>
            <input
              type="date"
              className="form-control"
              value={issueDate}
              onChange={(e) => setIssueDate(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Expiry Date</label>
            <input
              type="date"
              className="form-control"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Concern Person Name</label>
            <input
              type="text"
              className="form-control"
              value={concernPersonName}
              onChange={(e) => setConcernPersonName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Concern Person Phone</label>
            <input
              type="tel"
              className="form-control"
              value={concernPersonPhone}
              onChange={(e) => setConcernPersonPhone(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="btn btn-outline-success fw-bold"
            disabled={loading}
          >
            {loading ? "Uploading..." : "Replace File"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReplaceFile;
